import React from "react"
import Dialog from "material-ui/Dialog"
import { FlatButton, TextField, SelectField, MenuItem } from "material-ui"
import strings from "../../../../localization/strings"
import autobind from "class-autobind"
import { IBudgetUnitItem, IPosition, IScheduleBudgetUnitsSettings, IScheduleShift, IScheduleTemplate } from "../../../../models"
import _ from "lodash"
import * as hierarchyHelper from "../../../../helpers/hierarchyHelper"
import AccountStore from "../../../../stores/AccountStore"
import * as utils from "../../../../helpers/utils"
import { IScheduleBudgetDayPosition } from "../../../../models/data/scheduling/ScheduleBudgetDayPosition"

interface IProps {
    positions: IPosition[]
    handleClose(): void
    handleAdd(unit: IBudgetUnitItem, budgetedNumber: number, demandUnits: number, shiftTemplate: IScheduleShift): void
    handleEdit(id: string, unit: IBudgetUnitItem, budgetedNumber: number, demandUnits: number, shiftTemplate: IScheduleShift): void
    hierarchyId: string
    positionBudgetItem: IScheduleBudgetDayPosition
}
interface IState {
    openConfirmDialog: boolean
    unit: IBudgetUnitItem
    position: IPosition
    budgetedNumber: number
    demandUnits: number
    demandUnitName: string
    budgetUnitsSettings: IScheduleBudgetUnitsSettings
    shiftTemplate: IScheduleShift
}

export default class ScheduleTimeinfoAddBudgetDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)

        let hierarchyItemSettings = hierarchyHelper.getInheritedHierarchySettingItems(hierarchyHelper.getHierarchyItemById(this.props.hierarchyId))
        let budgetSettings = undefined
        if (!hierarchyItemSettings || !hierarchyItemSettings.ScheduleBudgetUnitsSettings) {
            budgetSettings = AccountStore.CurrentAccount.HierarchyItemSettings.ScheduleBudgetUnitsSettings
        } else {
            budgetSettings = hierarchyItemSettings.ScheduleBudgetUnitsSettings
        }

        this.state = {
            openConfirmDialog: false,
            position: undefined,
            budgetedNumber: !this.props.positionBudgetItem ? 1 : this.props.positionBudgetItem.BudgetedNumber,
            demandUnits: !this.props.positionBudgetItem ? 1 : this.props.positionBudgetItem.DemandUnits,
            demandUnitName: !this.props.positionBudgetItem ? "Unit" : this.props.positionBudgetItem.Unit.UnitName,
            budgetUnitsSettings: budgetSettings,
            unit: !this.props.positionBudgetItem ? undefined : this.props.positionBudgetItem.Unit,
            shiftTemplate: !this.props.positionBudgetItem ? undefined : this.props.positionBudgetItem.ShiftTemplate,
        }

        autobind(this)
    }

    getBudgetNumber(demandUnits) {
        let staffCount = this.state.unit.PerUnitFactor * demandUnits
        return Math.ceil(staffCount)
    }

    getPluralWord(word: string) {
        if (!word.endsWith("s")) {
            return word + "s"
        } else {
            return word
        }
    }

    render() {
        return (
            <Dialog
                open
                autoScrollBodyContent
                title={(!this.props.positionBudgetItem ? "Add Staff Plan Item" : "Edit Staff Plan Item '" + this.props.positionBudgetItem.Unit.UnitName + " to " + this.props.positionBudgetItem.Unit.PositionName + "'")}
                actions={[
                    <FlatButton
                        data-intercom-target={"AgreementTextDialog-Btn-CloseDialog"}
                        label={strings.CANCEL}
                        secondary
                        onTouchTap={() => { this.props.handleClose() }}
                    />,
                    <FlatButton
                        data-intercom-target={"AgreementTextDialog-Btn-CreateAgreementText"}
                        label={this.props.positionBudgetItem ? strings.Save : strings.Add}
                        primary
                        onTouchTap={() => {
                            if (this.props.positionBudgetItem) {
                                this.props.handleEdit(this.props.positionBudgetItem.Id, this.state.unit, this.state.demandUnits, this.state.budgetedNumber, this.state.shiftTemplate)
                            } else {
                                this.props.handleAdd(this.state.unit, this.state.demandUnits, this.state.budgetedNumber, this.state.shiftTemplate)
                            }
                        }}
                    />
                ]}
            >
                <div style={{ display: "grid", alignItems: "baseline"}}>
                    <div style={{ gridColumn: "1 / span 3", gridRow: 1 }}>
                        <SelectField
                            floatingLabelText={"Volume Unit"}
                            value={this.state.unit ? this.state.unit.Id : undefined}
                            onChange={(_e, _key, value) => {
                                this.setState({ unit: this.state.budgetUnitsSettings && this.state.budgetUnitsSettings.BudgetUnitItems.filter((item) => item.Id == value)[0] }, () => {
                                    this.setState({ budgetedNumber: this.state.unit ? this.getBudgetNumber(this.state.demandUnits) : this.state.budgetedNumber })
                                })
                            }}
                            style={{ width: "100%" }}
                        >
                            {this.state.budgetUnitsSettings && this.state.budgetUnitsSettings.BudgetUnitItems.map((unit, index) => (
                                <MenuItem key={index} value={unit.Id} primaryText={unit.UnitName + " to " + unit.PositionName} />
                            ))}
                        </SelectField>
                    </div>
                    <div style={{ gridColumn: "1 / span 3", gridRow: 2 }}>
                        <TextField
                            data-intercom-target={"Schedule-Demand-Count"}
                            type="number"
                            floatingLabelText={this.state.unit ? ("Number of " + this.getPluralWord(this.state.unit.UnitName)) : "Demand Volume Count"}
                            value={this.state.demandUnits}
                            step={1}
                            inputStyle={{ appearance: "auto" }}
                            onChange={(e, value) => {
                                const demandUnits = parseInt(value)
                                this.setState({ demandUnits: demandUnits, budgetedNumber: this.state.unit ? this.getBudgetNumber(demandUnits) : this.state.budgetedNumber })
                            }}
                            style={{ width: "100%" }}
                        />
                    </div>

                    <div style={{ gridColumn: 1, gridRow: 3, color: "#000", fontSize: 16 }}>
                        {this.state.unit && <span>{this.state.unit.PerUnitFactor} FACTOR = </span>}
                    </div>

                    <div style={{gridColumn: "2 / span 2", gridRow: 3}}>
                        <TextField
                            data-intercom-target={"Schedule-Budget-Count"}
                            type="number"
                            floatingLabelText={this.state.unit ? ("Number of " + this.getPluralWord(this.state.unit.PositionName)) : "Budgeted Staff Count"}
                            value={this.state.budgetedNumber}
                            step={1}
                            inputStyle={{ appearance: "auto" }}
                            onChange={(e, value) => {
                                this.setState({ budgetedNumber: parseInt(value) })
                            }}
                            style={{ width: "100%" }}
                        />
                    </div>

                    <SelectField
                        data-intercom-target={"Shift-AddShift-Select-Shift"}
                        floatingLabelText={strings.Shift_Template}
                        value={this.state.shiftTemplate ? this.state.shiftTemplate.Id : undefined}
                        onChange={(e, index, value) => this.setState({ shiftTemplate: AccountStore.getCurrentAccount().ScheduleData.ShiftTemplates.filter((item) => item.Id == value)[0] })}
                        style={{ width: 300, gridColumn: "1 / span 3" }}
                    >
                        {utils.sortAlphabetical(
                            AccountStore.getCurrentAccount().ScheduleData.ShiftTemplates,
                            "Name")
                            .map((shift) =>
                                <MenuItem value={shift.Id} primaryText={`${strings.Shift}: ${shift.Name}`} key={shift.Id} />
                            )}
                    </SelectField>
                </div>
            </Dialog>
        )
    }
}
